import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import MPP_ATTESTATION_DATA_BY_TIN from './MppAttestationDataByTin.gql';

const parseResult = (result) => {
  const initialState = {};

  const attestationDataResponse = get(result, 'mpp.getMppAttestationDataByTin');

  return {
    ...initialState,
    ...attestationDataResponse,
  };
};

export const useMppAttestationDataByTin = (options) => {
  const [queryResult, queryAction] = useQuery(MPP_ATTESTATION_DATA_BY_TIN, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
